import Vue from 'vue'
import axios from '@/libs/axios'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  checkHiddenAttr,
  designateOptions,
  designateValue,
  hasValue,
  transformField,
} from '@/helpers/formConditions'

const defaultState = () => {
  return {
    newChildForm: {},
    preparedFields: [],
    allConditions: [],
    hasFileField: false,
    hasSignatureField: false,
    isLoading: false,
    validTracker: false,
    familyName: '',
    serverMessage: '',
    errorMessage: '',
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    getIsLoading: state => state.isLoading,
    getNewChildForm: state => state.newChildForm,
    getHasFileField: state => state.hasFileField,
    getHasSignatureField: state => state.hasSignatureField,
    getPreparedFields: state => state.preparedFields,
    getAllConditions: state => state.allConditions,
    getValidTracker: state => state.validTracker,
    getServerMessage: state => state.serverMessage,
    getErrorMessage: state => state.errorMessage,
    getFamilyName: state => state.familyName,
  },
  mutations: {
    SET_IS_LOADING: (state, data) => {
      state.isLoading = data
    },
    SET_VALID_TRACKER: (state, data) => {
      state.validTracker = data
    },
    SET_SERVER_MESSAGE: (state, data) => {
      state.serverMessage = data
    },
    SET_ERROR_MESSAGE: (state, data) => {
      state.errorMessage = data
    },
    SET_FAMILY_NAME: (state, data) => {
      state.familyName = data
    },
    SET_FORMS_DATA: state => {
      let index = 0
      state.preparedFields = state.newChildForm.fields.map(field => {
        if (['avatar', 'file_upload'].includes(field.type)) state.hasFileField = true
        if (field.type === 'signature') state.hasSignatureField = true

        const ref = field.name + index
        index++

        if (field.attribute_field_name === '1#last_name') {
          field.default = state.familyName
        }

        return {
          id: field.id,
          ref: ref,
          value: designateValue(field.type, field.default, field.options),
          label: field.label,
          name: field.name,
          options: designateOptions(field.type, field.options),
          type: transformField(field.type),
          required: field.required,
          hidden: checkHiddenAttr(field.conditions.filter(item => item.action === 'Show')),
          use_prefill: field.use_prefill,
          attribute_field_name: field.attribute_field_name,
          password_repeat: null,
        }
      })

      state.allConditions =  state.newChildForm.conditions
    },
    CHECK_CONDITIONS: state => {
      state.allConditions.forEach(condition => {
        let isMatched
        for (let i = 0; i < condition.scoped_conditions.length; i++) {
          const scopeItems = condition.scoped_conditions[i];
          const scopeItemsResults = scopeItems.map(item => {
            const foundedField = state.preparedFields.find(field => field.id === item.field_id)
            return hasValue(item, foundedField.value)
          })
          isMatched = scopeItemsResults.every(i => i === true)
          if (isMatched || i == condition.scoped_conditions.length - 1) {

            if (condition.related_type === 'Field') {
              const field = state.preparedFields.find(field => field.id === condition.related_id)

              if (field) {
                field.hidden = condition.action === 'Show' ? !isMatched : isMatched
                if (!isMatched) {
                  field.value = designateValue(field.type, field.value, field.options)
                }
              }
            }
            break
          }
        }
      })
    },
    SET_NEW_CHILD_FORM: (state, data) => {
      state.newChildForm = data
    },
  },
  actions: {
    fetchSchoolNewChildForm(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`school-registration-forms/${queryParams.role}`, {
            params: queryParams.query,
            headers: {
              WithoutSchoolFilter: true,
            }
          })
          .then(response => {
            ctx.commit('SET_NEW_CHILD_FORM', response.data.data.form)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    updateChildInfo(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/my-children/${queryParams.user_id}`, queryParams.query)
          .then(response => {
            Vue.$toast({
              component: ToastificationContent,
              props: {
                title: "The User Data was successfully updated",
                icon: 'ThumbsUpIcon',
                variant: 'info',
              },
            })
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    createChild(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
            .post(`/my-children/`, queryParams)
          .then(response => {
            Vue.$toast({
              component: ToastificationContent,
              props: {
                title: "The Child was successfully created",
                icon: 'ThumbsUpIcon',
                variant: 'info',
              },
            })
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}